var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeviconAzure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 69,
    viewBox: "0 0 66 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1438 2.40952H41.4236L21.4098 64.4039C21.2042 65.0411 20.8126 65.5949 20.2901 65.9871C19.7676 66.3794 19.1406 66.5903 18.4973 66.5902H3.49331C3.00602 66.5901 2.52575 66.4687 2.09217 66.2362C1.65859 66.0037 1.28415 65.6667 0.999756 65.2531C0.715448 64.8393 0.529502 64.3607 0.457313 63.8569C0.385125 63.3531 0.428771 62.8385 0.584637 62.3558L19.2313 4.59532C19.437 3.9581 19.8286 3.40437 20.3511 3.01208C20.8735 2.61978 21.5005 2.40869 22.1438 2.40853V2.40952Z",
    fill: "url(#paint0_linear_2_3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.16 43.9913H19.587C19.3027 43.9907 19.0249 44.0797 18.7897 44.2467C18.5545 44.4137 18.3729 44.6509 18.2686 44.9274C18.1643 45.2038 18.1421 45.5068 18.2049 45.7967C18.2677 46.0865 18.4126 46.3499 18.6208 46.5524L38.2661 65.7225C38.8381 66.2803 39.5912 66.5905 40.3734 66.5904H57.685L50.16 43.9913Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1438 2.40952C21.4935 2.40697 20.8595 2.62184 20.3343 3.02274C19.8092 3.42365 19.4204 3.98959 19.2247 4.63792L0.60785 62.3033C0.441651 62.7878 0.389489 63.3069 0.455776 63.8169C0.522063 64.3268 0.704849 64.8126 0.988675 65.2331C1.2725 65.6536 1.64902 65.9965 2.08638 66.2327C2.52374 66.4689 3.00909 66.5915 3.50136 66.5902H18.893C19.4662 66.4831 20.002 66.2189 20.4456 65.8245C20.8891 65.4302 21.2247 64.9197 21.4178 64.3454L25.1302 52.9067L38.3917 65.8377C38.9473 66.3183 39.6443 66.584 40.3654 66.5902H57.6128L50.0482 43.9911L27.9972 43.9966L41.4933 2.40952H22.1438Z",
    fill: "url(#paint1_linear_2_3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.769 4.59234C46.5636 3.95603 46.1725 3.4031 45.6507 3.0115C45.1289 2.61989 44.5026 2.40934 43.8603 2.40952H22.3736C23.0159 2.4096 23.6419 2.62025 24.1636 3.01183C24.6853 3.40341 25.0764 3.95619 25.2818 4.59234L43.929 62.3553C44.0851 62.8381 44.129 63.3528 44.057 63.8568C43.985 64.3608 43.7991 64.8397 43.5149 65.2537C43.2307 65.6677 42.8562 66.0049 42.4225 66.2375C41.9887 66.4701 41.5083 66.5914 41.0208 66.5912H62.5084C62.9957 66.5908 63.4759 66.4693 63.9093 66.2365C64.3427 66.0038 64.717 65.6665 65.0011 65.2527C65.2852 64.8388 65.471 64.3602 65.5432 63.8564C65.6153 63.3526 65.5718 62.8381 65.4161 62.3553L46.769 4.59234Z",
    fill: "url(#paint2_linear_2_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_3",
    x1: 29.171,
    y1: 7.16555,
    x2: 7.49421,
    y2: 68.4189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_3",
    x1: 35.4252,
    y1: 35.9841,
    x2: 30.7532,
    y2: 37.4949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_3",
    x1: 32.8781,
    y1: 5.36173,
    x2: 56.6275,
    y2: 65.8829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviconAzure);
export default __webpack_public_path__ + "static/media/devicon_azure.c0bf63f8fd2593e326d3a63495a2b45a.svg";
export { ForwardRef as ReactComponent };